export const getRandomSubarray = <T>(array: T[], length: number): T[] => {
  if (length > array.length) {
    throw new Error('Requested subarray is larger than original array');
  }

  return array.sort(() => 0.5 - Math.random()).slice(0, length);
};
